export default __webpack_public_path__ + "static/media/rocket_anim_117.513b0d65.png";